import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class LotteryLatestService {
    // jQuery.support.cors = true;

    constructor(
        private httpService: HttpService) { }

    //获取最新的开奖号码
    getLotteryOpenLatest() {
        var url = AppConfig.GetProdUrl() + "/Lottery/GetLotteryOpenLatest";

        return this.httpService.get(url);
    }

    //获取所有彩种
    //TQQ 2017-01-12
    getLotterys() {
        var url = AppConfig.GetProdUrl()+"/Lottery/GetLotterys";
        return this.httpService.get(url);
    }



}



// WEBPACK FOOTER //
// ./src/services/lotteryLatest.service.ts